export default {
  forms: [],
  pagination: {},
  form: {}
}
